import me from "models/me";
import { getStore } from "store";
import { fetchMerchantEnablements } from "../actions/merchant-enablement";

export default function (_nextState, replace, callback) {
    const store = getStore();

    if (me.isSignedIn()) {
        store.dispatch(fetchMerchantEnablements());
        callback();
    } else {
        replace({
            pathname: "/404",
        });
        callback();
    }
}
